<template>
    <v-menu
        v-model="mostrar"
        :close-on-content-click="false"
        offset-y>
        <template
            v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on">
                <v-icon>
                    mdi-filter
                </v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Filtros
            </v-card-title>
            <v-card-text>
                <v-row no-gutters>
                  <custom-select
                    v-model="filtros.tipos"
                    label="Tipo"
                    item-value="tipo"
                    item-text="tipo"
                    multiple
                    clearable
                    chips
                    small-chips
                    deletable-chips
                    :items="tiposOficios">
                  </custom-select>
                </v-row>
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<script>
import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'ProgramacionFiltros',
  props: {
    listaOficiosAutorizacion: {
      type: Array,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomSelect,
  },
  data() {
    return {
      mostrar: false,
    };
  },
  computed: {
    tiposOficios() {
      const tiposDeOficios = this.listaOficiosAutorizacion
        .map((oficio) => ({
          id: oficio.id,
          tipo: oficio.tipo,
        }));
      if (tiposDeOficios.length <= 0) return [];
      return this.$removerDumplicadosArrayObj(tiposDeOficios, 'tipo')
        .sort((a, b) => (`${a.tipo}`).localeCompare(b.tipo));
    },
  },

};
</script>

<style lang="scss">

</style>
